module.exports = __webpack_public_path__ + "img/up.f76f7061.svg";